import { FlexColumn, FlexRow } from '@editor/components/utilities/layouts';
import { H3, P2 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const PlanBox = styled.div`
  border-radius: ${themeStyle.radiusLarge};
  border: 1px solid ${themeStyle.varInkLight};
  background-color: ${({ theme }) => theme.backgroundColor};
  padding: 40px 32px;
  box-shadow: ${({ theme }) => theme.boxShadow};

  html[data-theme='dark'] &&,
  .dark && {
    box-shadow: none;
  }
`;

export const PlanInfoTitle = styled(H3).attrs({
  as: 'div',
})`
  margin: 0 0 20px;
  text-align: center;
`;

export const PlanInfoDescription = styled(P2).attrs({
  as: 'div',
})`
  color: ${themeStyle.varInkMedium};
`;

export const PlanInfoRow = styled(FlexRow)`
  align-items: center;
  gap: 12px;

  & + & {
    margin-top: 8px;
  }
`;

export const PlanInfoWrapper = styled.div`
  margin: 0 auto;
`;

export const TeamHeader = styled(FlexRow)`
  border-radius: ${themeStyle.radiusLarge};
  border: 1px solid ${themeStyle.varInkLight};
  padding: 12px;
  gap: 8px;
  align-items: center;

  > :last-child {
    margin-left: auto;
  }
`;

export const TeamWrapper = styled(FlexColumn)`
  padding: 24px 12px;

  > ${PlanBox} {
    margin-top: 24px;
  }

  ${QUERIES.laptopAndUp} {
    padding: 32px;
  }
`;
